import {ACTION_CODE} from './_actionCode';
import {ExpenseService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_EXPENSE';

export async function createDealExpense(userData: Record<string, any>, payloadExpense: any) {
    try {
        LoggerService.logInfo('Action - createExpense - Start');

        const createExpenseResult = await ExpenseService.createExpense(userData, payloadExpense);

        LoggerService.logInfo('Action - createExpense - End - Success');

        return ResultModel.newSuccessResult(createExpenseResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createExpense - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
